import { CalculatorRecommendations } from './CalculatorResult.types';

export const defaultRecommendations: CalculatorRecommendations = {
  __typename: 'SolarRecommendations',
  estimatedSystemSizeWatts: 4200,
  primaryRecommendationId: 'mediumB',
  recommendations: [
    {
      __typename: 'SolarRecommendation',
      id: 'miniB',
      solarSaving: {
        payoffTimeYears: 6.4,
        __typename: 'SolarSaving',
        billCostForPeriod: null,
        billPeriod: null,
        billSavingsForPeriod: null,
        usagePercentDuringDay: null,
        solarEnergyConsumedKwh: null,
        solarEnergyConsumptionRateCents: null,
        solarEnergyConsumedDollars: null,
        solarEnergySoldKwh: null,
        solarEnergySoldDollars: null,
        solarEnergySoldRateCents: null
      },
      solarSystem: {
        __typename: 'SolarSystem',
        name: 'Mini system',
        description: 'Suits 1–2 person households',
        inverter: {
          __typename: 'Inverter',
          watts: 2000
        },
        size: 'Mini',
        id: 'miniDefault',
        totalCost: 3795,
        solarPanels: {
          __typename: 'SolarPanels',
          panelCount: 8
        }
      }
    },
    {
      __typename: 'SolarRecommendation',
      id: 'smallB',
      solarSaving: {
        payoffTimeYears: 4.9,
        __typename: 'SolarSaving',
        billCostForPeriod: null,
        billPeriod: null,
        billSavingsForPeriod: null,
        usagePercentDuringDay: null,
        solarEnergyConsumedKwh: null,
        solarEnergyConsumptionRateCents: null,
        solarEnergyConsumedDollars: null,
        solarEnergySoldKwh: null,
        solarEnergySoldDollars: null,
        solarEnergySoldRateCents: null
      },
      solarSystem: {
        __typename: 'SolarSystem',
        name: 'Small system',
        description: 'Suits 2–3 person households',
        inverter: {
          __typename: 'Inverter',
          watts: 3000
        },
        size: 'Small',
        id: 'smallDefault',
        totalCost: 4395,
        solarPanels: {
          __typename: 'SolarPanels',
          panelCount: 12
        }
      }
    },
    {
      __typename: 'SolarRecommendation',
      id: 'mediumB',
      solarSaving: {
        payoffTimeYears: 3.9,
        __typename: 'SolarSaving',
        billCostForPeriod: null,
        billPeriod: null,
        billSavingsForPeriod: null,
        usagePercentDuringDay: null,
        solarEnergyConsumedKwh: null,
        solarEnergyConsumptionRateCents: null,
        solarEnergyConsumedDollars: null,
        solarEnergySoldKwh: null,
        solarEnergySoldDollars: null,
        solarEnergySoldRateCents: null
      },
      solarSystem: {
        __typename: 'SolarSystem',
        name: 'Medium system',
        description: 'Suits 3–4 person households',
        inverter: {
          __typename: 'Inverter',
          watts: 4000
        },
        size: 'Medium',
        id: 'mediumDefault',
        totalCost: 4695,
        solarPanels: {
          __typename: 'SolarPanels',
          panelCount: 16
        }
      }
    },
    {
      __typename: 'SolarRecommendation',
      id: 'largeB',
      solarSaving: {
        payoffTimeYears: 3.2,
        __typename: 'SolarSaving',
        billCostForPeriod: null,
        billPeriod: null,
        billSavingsForPeriod: null,
        usagePercentDuringDay: null,
        solarEnergyConsumedKwh: null,
        solarEnergyConsumptionRateCents: null,
        solarEnergyConsumedDollars: null,
        solarEnergySoldKwh: null,
        solarEnergySoldDollars: null,
        solarEnergySoldRateCents: null
      },
      solarSystem: {
        __typename: 'SolarSystem',
        name: 'Large system',
        description: 'Suits 4+ person households',
        inverter: {
          __typename: 'Inverter',
          watts: 5000
        },
        size: 'Large',
        id: 'largeDefault',
        totalCost: 5295,
        solarPanels: {
          __typename: 'SolarPanels',
          panelCount: 22
        }
      }
    }
  ]
};
